import { z } from 'zod';

export const mediaCardSchema = z.object({
  titulo: z.string(),
  pontuacao: z.number().nullish(),
  qtdEscola: z.number().nullish(),
  perfil: z.string().nullish(),
});

export type MediaCard = z.infer<typeof mediaCardSchema>;

export const escolaHeaderResponseSchema = z.object({
  medias: z.array(mediaCardSchema).nullish(),
});

export type EscolaHeaderResponse = z.infer<typeof escolaHeaderResponseSchema>;
